import script from "./FaqAccordion.vue?vue&type=script&setup=true&lang=js"
export * from "./FaqAccordion.vue?vue&type=script&setup=true&lang=js"

import "./FaqAccordion.vue?vue&type=style&index=0&id=525ec054&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-525ec054"]])

export default __exports__